<template>
  <v-sheet class="text-start">
    <page-head
      title="Create Instructor"
      :breadcrumb="['Class', 'Instructors', 'Create']"
    >
    </page-head>
    <v-form class="ma-3" ref="form" @submit.prevent="onFormSubmit">
      <h2 class="my-5">Instructor</h2>
      <v-text-field
        label="Name"
        :rules="RULES.notEmpty"
        v-model="nameValue"
        variant="outlined"
      ></v-text-field>
      <v-btn class="mt-2" type="submit" variant="outlined" block color="primary"
        >Create</v-btn
      >
    </v-form>
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { authAxios } from "@/util/Axios";
import { ref } from "vue";
import { RULES } from "@/util/Form";
import { useRouter } from "vue-router";

const axios = authAxios();
const router = useRouter();

const form = ref(null);
const nameValue = ref("");

async function onFormSubmit() {
  const { valid } = await form.value.validate();
  if (valid) {
    submitCreateInstructor(nameValue.value).then(() => {
      router.go(-1);
    });
  }
}

function submitCreateInstructor(name) {
  return axios({
    method: "POST",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/instructor`,
    data: { name },
  });
}
</script>
